import { jsx as r } from "react/jsx-runtime";

import { startOfHour as e } from "date-fns";

import o from "../CalendarSlot/index.js";

import { useMemo as t, useCallback as l } from "react";

import { useProviderSchedule as a } from "../../hooks/useProviderSchedule.js";

const i = ({hour: i}) => {
    const {slots: s, toggleDrawer: m} = a(), f = t((() => s?.filter((r => e(new Date(r.startTime)).valueOf() === e(i).valueOf())) || []), [ s, i ]), u = l((() => {
        m(!0, {
            hour: i
        })();
    }), [ i, m ]);
    return r("div", {
        className: "relative h-full w-full",
        children: f.map((e => r(o, {
            slot: e,
            onAvailableSlotClick: u
        }, e.id)))
    });
};

export { i as default };
//# sourceMappingURL=index.js.map
